import { isAddress } from 'viem';

export interface ParseBatchAddressesResult {
  addresses: Array<string>;
  invalidAddresses: Array<string>;
}

export default function parseBatchAddresses(input: string): ParseBatchAddressesResult {
  const trimmed = input.trim();

  if (!trimmed) {
    return { addresses: [], invalidAddresses: [] };
  }

  let candidates: Array<string> = [];

  if (trimmed.startsWith('[')) {
    try {
      const parsed = JSON.parse(trimmed);

      if (Array.isArray(parsed)) {
        candidates = parsed.map(String);
      }
    } catch { /* fall through to line-by-line parsing */ }
  }

  if (candidates.length === 0) {
    candidates = trimmed
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter(Boolean);
  }

  const addresses: Array<string> = [];
  const invalidAddresses: Array<string> = [];

  for (const candidate of candidates) {
    if (isAddress(candidate)) {
      addresses.push(candidate);
    } else {
      invalidAddresses.push(candidate);
    }
  }

  // Preserve duplicate addresses in input order.
  return { addresses, invalidAddresses };
}
